// extracted by mini-css-extract-plugin
export default {"tpl-btns":"downLoadTpl-module__tpl-btns--RrQNf"};